module.exports = __webpack_public_path__ + "img/masuyama.9cc21fa1.jpg";